// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__gBDMw"};